import { Link, useParams, useSearchParams } from "react-router-dom";

import { Button } from "@/components/ui/button";

export function AfterCall() {
  const { key } = useParams();
  //get reason from query params
  const [searchParams] = useSearchParams();
  const reason = searchParams.get("reason");

  const isRemoved = reason === "removed";

  return (
    <div className="flex h-full items-center justify-center bg-background">
      <div className="max-w-screen-sm px-4 text-center sm:px-6 lg:px-8">
        <p className="mb-2 text-center text-2xl text-foreground">
          {isRemoved
            ? "The organiser either ended the session or you have been removed."
            : "You've left the meeting"}
        </p>

        <div className="flex justify-center gap-2">
          <Button size="lg" variant="outline" asChild>
            <Link to={`/`}>Back to home</Link>
          </Button>
          <Button size="lg" variant="default" asChild>
            <Link to={`/r/${key}`}>Rejoin</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
